// extracted by mini-css-extract-plugin
export var column = "_sz-0";
export var divider = "_sz-2";
export var timePicker = "_sz-1";